import PropTypes from "prop-types"
import { Grid } from "@mui/material"
import { RadioButton } from "components/fields"
import { useFormContext } from "react-hook-form"
import { CAMPUS_MEETING, PHONE_CALL } from "../services/landingPages"

const RendezVous = ({ campusLabel, label = "Échanger avec l'équipe des Admissions" }) => {
  const { control } = useFormContext()

  const options = [
    { label: 'Rendez-vous téléphonique', value: PHONE_CALL },
    { label: `Rendez-vous sur ${campusLabel}`, value: CAMPUS_MEETING }
  ]

  return (
    <Grid item xs={12}>
      <RadioButton control={control} label={label} name="rendezVous" options={options} required />
    </Grid>
  )
}

RendezVous.propTypes = {
  campusLabel: PropTypes.string.isRequired,
  label: PropTypes.string
}

export default RendezVous
